module.exports = __webpack_public_path__ + "img/assisi_background_hero.d2a0ca1d.png";